import React, { useContext } from 'react';
import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
// import { AppContext } from 'views/App/context';
import QuickAction from 'components/_atoms/QuickAction';
import { ArrowOutward, BarChart, InventoryOutlined, LocalPoliceOutlined } from '@mui/icons-material';
import { getLmsUrl } from 'data_sources/constants';

export default function TrainingSolutions() {
  // const { currentOrganizationId, hasAppPermission, hasPermission } = useContext(AppContext);

  return (
    <Card className='training-solutions'>
      <CardHeader title={t('dashboard.training.trainingSolutions.title')} />
      <CardContent>
        <Stack spacing={2}>
          <QuickAction
            id='report'
            title={t('dashboard.training.trainingSolutions.report.title')}
            subtitle={t('dashboard.training.trainingSolutions.report.subtitle')}
            href={getLmsUrl('/analytics/reports/')}
            startIcon={<BarChart />}
            endIcon={<ArrowOutward />}
          />
          <QuickAction
            id='assignments'
            title={t('dashboard.training.trainingSolutions.assignments.title')}
            subtitle={t('dashboard.training.trainingSolutions.assignments.subtitle')}
            href={getLmsUrl('/assigned-learning/')}
            startIcon={<InventoryOutlined />}
            endIcon={<ArrowOutward />}
          />
          <QuickAction
            id='credentials'
            title={t('dashboard.training.trainingSolutions.credentials.title')}
            subtitle={t('dashboard.training.trainingSolutions.credentials.subtitle')}
            href={getLmsUrl('/credentials/members/')}
            startIcon={<LocalPoliceOutlined />}
            endIcon={<ArrowOutward />}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
